import { createFileRoute } from "@tanstack/react-router";
import { DashboardsPage } from "../components/dashboards/DashboardsPage";

/** Every dashboard the person may see (BUILD_SPEC §16.5). */
export const Route = createFileRoute("/admin/dashboards/")({ component: DashboardsPage });
